import { render, staticRenderFns } from "./AddApprentice.vue?vue&type=template&id=7539d186&"
import script from "./AddApprentice.vue?vue&type=script&lang=js&"
export * from "./AddApprentice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports